/* eslint-disable no-console */
import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

import { debounce } from 'lodash';
import { SiteHeader } from '../SiteHeader/SiteHeader';

@Component
export class PredictiveSearch extends ThemeComponent {
    @Ref() searchInput!: HTMLInputElement;
    @Ref() searchResults!: HTMLDivElement;
    @Ref({ required: false }) close!: HTMLButtonElement;

    scrollListener: (() => void)|null = null;
    private siteHeaderSearch: HTMLElement | null = this.closest('.site-header__search');
    private siteHeader: SiteHeader|null = this.closest('site-header');

    private _onSearchInput = new SimpleEvent<boolean>();
    public get onSearchInput() {
        return this._onSearchInput.asEvent();
    }

    init() {
        this.$listen(this.searchInput, 'input', debounce(() => {
            this.onChange();
            this._onSearchInput.dispatch(true);
        }, 300));

        window.addEventListener('resize',
            debounce(() => {
                this.closeResults();
            }, 300)
        );

        // if (!this.siteHeader) { return; }
        // this.$subscribe(this.siteHeader.onSearchClose, () => this.handleClose());

        // Close the search
        if (this.close ) {
            this.$listen(this.close, 'click', () => {
                this.handleClose();
            });
        }


        if (!this.siteHeaderSearch) { return; }
        // if (window.innerWidth < 1024) { return; }
        this.$listen(this.siteHeaderSearch, 'focusout', () => {
            setTimeout(() => {
                if (!this.contains(document.activeElement)) {
                    this.closeResults();
                }
            }, 200);
        });
    }

    handleClose() {
        this.clearResults();
        this.clearInput();
        this.closeResults();
    }

    onChange() {
        const searchTerm: string = this.searchInput.value.trim();

        if(!searchTerm.length) {
            this.handleClose();
            return;
        }

        this.getResults(searchTerm);
    }

    appendResults(text: string): void {
        const format: Document = new DOMParser().parseFromString(text, 'text/html');
        const resultsMarkup: string | undefined =
            format.querySelector('#shopify-section-predictive-search')?.innerHTML || undefined;

        if(resultsMarkup === undefined) {
            return;
        }

        this.searchResults.innerHTML = resultsMarkup;
    }

    clearResults(): void {
        const results: HTMLDivElement | null = this.querySelector('#predictive-search-results') || null;

        this.searchInput.value = '';
        if(results) {
            results.innerHTML = '';
        }
    }

    openResults(): void {
        this.setAttribute('open', 'true');
        this.toggleScrollEvent(); // add scroll event
    }

    closeResults(): void {
        this.setAttribute('open', 'false');
        this.toggleScrollEvent(); // remove scroll event
    }

    scrollOccured() {
        if (window.innerWidth < 1024) { return; }
        // this.searchInput.value = "";
        // this.handleClose();
    }

    getResults(searchTerm: string): void {
        const url: string =
            // eslint-disable-next-line max-len
            `/search/suggest?q=${searchTerm}&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku&resources[type]=product,page,article,collection&resources[limit]=4&resources[limit_scope]=each&section_id=predictive-search`;

        fetch(url)
            .then((response) => {
                if(!response.ok) {
                    throw new Error(`${response.status}`);
                }
                return response.text();
            })
            .then((text) => {
                this.appendResults(text);
                this.openResults();
            })
            .catch((error) => {
                throw error;
            });
    }

    toggleScrollEvent() {
        if (!this.scrollListener) {
            this.scrollListener = () => this.scrollOccured();
            window.addEventListener('scroll', this.scrollListener);
        } else {
            window.removeEventListener('scroll', this.scrollListener);
            this.scrollListener = null;
        }
    }

    clearInput() {
        this.searchInput.value = '';
    }
}
